import type { LinkedAccountItem, LinkedAccountType } from '../../types/linkedAccount'

/**
 * Nhãn + thứ tự hiển thị của luồng tài khoản liên kết (SP-005).
 *
 * 🔴 Loại "Khác": badge in ĐÚNG chữ "Khác", tên tự nhập nằm ở DÒNG PHỤ `Loại tài khoản: …`
 * (người dùng chốt 17/09/2026). Cố ý khác gợi ý §2 của BE contract ("other → hiển thị
 * custom_type_name") — đừng "sửa lại cho khớp tài liệu BE".
 */

const BADGE_LABEL: Record<LinkedAccountType, string> = {
  vinaphone: 'Vinaphone',
  viettel: 'Viettel',
  other: 'Khác',
}

/** Thứ tự nghiệp vụ: nhà mạng chính trước, nhóm tự đặt tên dồn xuống cuối. */
const TYPE_ORDER: Record<LinkedAccountType, number> = {
  vinaphone: 0,
  viettel: 1,
  other: 2,
}

export const accountTypeBadgeLabel = (item: LinkedAccountItem): string => BADGE_LABEL[item.account_type]

/** Tên loại tự nhập để dựng dòng phụ; `null` nghĩa là không dựng dòng nào. */
export const customTypeLine = (item: LinkedAccountItem): string | null => {
  if (item.account_type !== 'other') return null
  const name = (item.custom_type_name ?? '').trim()
  return name === '' ? null : name
}

/**
 * Vinaphone → Viettel → Khác; trong nhóm Khác theo tên tự nhập A→Z; cùng loại thì mới tạo trước.
 * BE đã trả đúng thứ tự LOẠI (contract §4.1) — FE sắp lại để khoá thêm thứ tự trong nhóm Khác và
 * để không phụ thuộc thứ tự của một lần gọi.
 */
export const sortLinkedAccounts = (
  items: readonly LinkedAccountItem[],
): LinkedAccountItem[] => [...items].sort((a, b) => {
  const byType = TYPE_ORDER[a.account_type] - TYPE_ORDER[b.account_type]
  if (byType !== 0) return byType

  const nameA = customTypeLine(a)
  const nameB = customTypeLine(b)
  if (nameA !== null && nameB !== null) {
    const byName = nameA.localeCompare(nameB, 'vi')
    if (byName !== 0) return byName
  }

  return b.created_at.localeCompare(a.created_at)
})
